import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { supabase } from "../lib/supabaseClient";

function ProtectedAdminRoute({ children }) {
    const [session, setSession] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        async function loadSession() {
            const { data, error } = await supabase.auth.getSession();

            if (!isMounted) return;

            if (error) {
                console.error(error.message);
                setSession(null);
            } else {
                setSession(data.session);
            }

            setIsLoading(false);
        }

        loadSession();

        const {
            data: { subscription },
        } = supabase.auth.onAuthStateChange((_event, currentSession) => {
            if (isMounted) {
                setSession(currentSession);
                setIsLoading(false);
            }
        });

        return () => {
            isMounted = false;
            subscription.unsubscribe();
        };
    }, []);

    if (isLoading) {
        return (
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#fffaf2",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    if (!session) {
        return <Navigate to="/admin/login" replace />;
    }

    return children;
}

export default ProtectedAdminRoute;